import * as React from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { DEFAULT_DATE_RANGE_PARAM, WATCH_LIST_QUERY_PARAMS } from 'pages/TrackAndTrace/constants';
import _ from 'lodash';
import { GatedOutFilterKind, getGatedOutFilters } from './parsers/gated-out';

export interface FilterStates {
  today: boolean;
  yesterday: boolean;
}

export const GatedOutDateFilter: React.FC = () => {
  const controlLabelClasses = {
    label: 'font-medium text-sm py-1',
    root: 'm-0 hover:bg-blue-200 rounded-sm',
  };
  const { searchParams, setSearchParams } = useCustomSearchParams(WATCH_LIST_QUERY_PARAMS, true);

  const [filterStates, setFilterStates] = React.useState<FilterStates>({
    today: false,
    yesterday: false,
  });

  React.useEffect(() => {
    const filters = getGatedOutFilters(searchParams);
    setFilterStates({
      today: !!filters.find((f) => f.kind === GatedOutFilterKind.Today),
      yesterday: !!filters.find((f) => f.kind === GatedOutFilterKind.Yesterday),
    });
  }, [searchParams]);

  const clearFilters = () => {
    setSearchParams({
      gatedOutAt: null,
    });
  };

  const handleChange = (v: 'today' | 'yesterday') => {
    const newFilterState = filterStates;

    newFilterState[v] = !newFilterState[v];

    const defaultSearchParams = {
      containerStatus: _.uniq(_.concat(searchParams.containerStatus, 'gated_out')),
    };

    if (newFilterState.today && newFilterState.yesterday) {
      setSearchParams({
        ...defaultSearchParams,
        gatedOutAt: {
          ...DEFAULT_DATE_RANGE_PARAM,
          startDate: '-1:days',
          endDate: 'today',
        },
      });
    } else if (newFilterState.today) {
      setSearchParams({
        ...defaultSearchParams,
        gatedOutAt: {
          ...DEFAULT_DATE_RANGE_PARAM,
          exactDate: 'today',
        },
      });
    } else if (newFilterState.yesterday) {
      setSearchParams({
        ...defaultSearchParams,
        gatedOutAt: {
          ...DEFAULT_DATE_RANGE_PARAM,
          exactDate: '-1:days',
        },
      });
    } else {
      clearFilters();
    }
  };

  return (
    <FormGroup className="px-2">
      <FormControlLabel
        classes={controlLabelClasses}
        control={
          <Checkbox
            size="small"
            checked={filterStates.today}
            onChange={() => handleChange('today')}
          />
        }
        label="Today"
      />
      <FormControlLabel
        classes={controlLabelClasses}
        control={
          <Checkbox
            size="small"
            checked={filterStates.yesterday}
            onChange={() => handleChange('yesterday')}
          />
        }
        label="Yesterday"
      />
    </FormGroup>
  );
};
GatedOutDateFilter.displayName = 'TrackAndTrace.Controls.filters.GatedOutDateFilter';
